export const APP_VARIABLES = {
    // LocalStorage item names
    currentUser: 'CURRENT_USER',
    currentDonate: 'CURRENT_DONATE',
    lastSeenPage: 'LASTSEENPAGE',
};
